import { useState } from "react";
import { Button } from "../../ui/button";
import { Dialog, DialogClose, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from "../../ui/dialog";
import apiCompressores from "../../../services/apis/apiCompressores";
import { useToast } from "../../../contexts/ToastContext";

export default function TrocarStatusManutencao({children, compressor, manutencao}) {

    const [open, setOpen] = useState(false);
    const { sucesso, erro, aviso } = useToast();
    
    const handleToggleManutencao = async () => {
        try {
            if(manutencao) {
                aviso("O compressor já está em manutenção.");
                return;
            }

            await apiCompressores.setStatusManutencao(compressor.id);
            sucesso("Status de manutenção trocado com sucesso!");
            setOpen(false);
        } catch (error) {
            erro("Erro ao trocar o status de manutenção. Tente novamente.");
            setOpen(false);
        }
    }

    return (
        <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger disabled={manutencao}>
                {children}
            </DialogTrigger>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle className={"mb-5"}>
                        Trocar o status do compressor {compressor?.nome} para manutenção?
                    </DialogTitle>
                    <DialogDescription>
                        O compressor permanecerá em manutenção até receber uma nova leitura.
                    </DialogDescription>
                </DialogHeader>
                <DialogFooter>
                        <Button onClick={() => setOpen(false)}>
                            Cancelar
                        </Button>
                        <Button onClick={handleToggleManutencao} className={"bg-yellow-500/70 py-2 px-4 rounded-md hover:bg-yellow-500 hover:cursor-pointer border-slate-800 border-2 transition-all duration-200 ease-in-out border-none !ring-yellow-400"}>
                            Trocar
                        </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}